









import { computed, defineComponent, PropType, toRef } from '@vue/composition-api';
import { bemx } from '@berlin-front/common/utils';
import { AlertType, ALERT_TYPE, useAlertIconImgSrc } from './composable';

/**
 * ## アラートメッセージ（by AtoneComponents）
 *
 * AtoneComponents（https://www.figma.com/file/3wDz65HMOrLdZT63s0N7nS/atone_Components?node-id=0%3A5037）のデザインにあるアラートメッセージ。
 * デザイン種類には、情報、警告、エラー、成功の4つのパターンがある。
 * Vuetifyの`v-alert`コンポーネントのラッパー。
 * 見た目はVuetify標準のOutlinedデザインをベースに、角の丸みや色をCSSで上書きしている。
 *
 * Vuetifyの`v-alert`については以下を参照。
 *
 * - 仕様書：https://vuetifyjs.com/ja/api/v-alert/
 * - コード：https://github.com/vuetifyjs/vuetify/tree/master/packages/vuetify/src/components/VAlert
 *
 */
export default defineComponent({
  name: 'AtoneAlert',
  props: {
    /**
     * アラート種別。
     *
     * エラー（error）または警告（warning）または情報（info）または成功（success）を指定する。
     */
    alertType: {
      type: String as PropType<AlertType>,
      default: ALERT_TYPE.ERROR,
    },
  },

  setup(props) {
    const type = toRef(props, 'alertType');
    const imgSrc = useAlertIconImgSrc(type);

    const className = computed(() => bemx('AtoneAlert', type.value));

    return {
      className,
      imgSrc,
    };
  },
});
